export default {
      id: "icon-menu-close-usage",
      viewBox: "0 0 15.2 15.2",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-menu-close",
      toString: function () {
        return this.url;
      }
    }